import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Checkout } from './components/Checkout';
import { Footer } from './components/Footer';
import { StickyBar } from './components/StickyBar';
import { CountdownTimer } from './components/CountdownTimer';
import { LiveViewers } from './components/LiveViewers';
import { MetaPixel } from './components/MetaPixel';
import { MetaHead } from './components/MetaHead';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="font-sans bg-[#FDF8F3] text-[#333333] min-h-screen" data-id="element-0">
      <MetaHead data-id="element-1" />
      <MetaPixel data-id="element-2" />
      <Header data-id="element-3" />
      <CountdownTimer data-id="element-4" />
      <LiveViewers data-id="element-5" />
      <main data-id="element-6">
        <Hero data-id="element-7" />
        <Problem data-id="element-8" />
        <Features data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <Checkout data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyBar data-id="element-15" />
      <PurchasePopup data-id="element-16" />
    </div>;
}